import { render, staticRenderFns } from "./NotificationMenu.vue?vue&type=template&id=207909d0&scoped=true&"
import script from "./NotificationMenu.vue?vue&type=script&lang=js&"
export * from "./NotificationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207909d0",
  null
  
)

export default component.exports